import categoryList from './categoryList'

export default categoryList
